export let LABELS = {
    NAME: "Name",
    NO_OF_AUDIOS: "No. of Audios",
    STATUS: "Status",
    ACTION: "Action",
    DEGREE: "Degree",
    LICENSE: "License",
    ABOUT_AUTHOR: "About Author",
    AUTHOR_IMAGE: "Author Image"
};

export let NAMES = {
    [LABELS.NAME]: "name",
    [LABELS.NO_OF_AUDIOS]: "audio",
    [LABELS.LICENSE]: "license",
    [LABELS.DEGREE]: "degree",
    [LABELS.STATUS]: "Status",
    [LABELS.ABOUT_AUTHOR]: "aboutAuthor",
    [LABELS.AUTHOR_IMAGE]: "authorImage"
};

export let PLACEHOLDERS = {
    [LABELS.NAME]: "Enter Name",
    [LABELS.NO_OF_AUDIOS]: "Enter No of Audios",
    [LABELS.STATUS]: "Status",
    [LABELS.ABOUT_AUTHOR]: "Enter About Author",
    [LABELS.AUTHOR_IMAGE]: "Enter Author Image",
    [LABELS.LICENSE]: "Enter License",
    [LABELS.DEGREE]: "Enter Degree"
};
